import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'
import { useMemo } from 'react'

export default function SelectNacionalidade({
    value, 
    error,
    errorMessage,
    required,
    onChange
}: SelectNacionalidadeProps) {

    const opcoesRadio = useMemo(() => [
        { value: "Brasileiro(a)", label: "Brasileiro(a)" },
        { value: "Estrangeiro(a)", label: " Estrangeiro(a)" },
    ], []);
    return (
        <FormControl fullWidth error={error} required={required}>
            <InputLabel id="nacionalidade-select">Nacionalidade</InputLabel>
            <Select
                labelId="nacionalidade-select"
                label="Nacionalidade"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {opcoesRadio.map((opcao, index) => (
                    <MenuItem key={index} value={opcao.value}>{opcao.label}</MenuItem>
                ))}
            </Select>
            {error && <FormHelperText>{errorMessage}</FormHelperText>}
        </FormControl>
    )
}

interface SelectNacionalidadeProps {
    value: string;
    onChange: (value: string) => void;
    error: boolean
    errorMessage?: string;
    required: boolean;
}
